var map = {
	"./access-vip-areas-nlp-color.svg": 7594,
	"./contact-center-24-nlp-color.svg": 4677,
	"./contact-center-vip-nlp-color.svg": 4097,
	"./discount-booster-nlp-color.svg": 8249,
	"./discounts-on-food-drink-nlp-color.svg": 1232,
	"./early-check-in-and-late-check-out-nlp-color.svg": 3335,
	"./favorite-hotel-pin-nlp-color.svg": 541,
	"./favorite-room-nlp-color.svg": 8127,
	"./free-breakfast-for-two-nlp-color.svg": 130,
	"./in-room-welcome-gift-nlp-color.svg": 8867,
	"./luggage-storage-nlp-color.svg": 2080,
	"./members-only-rate-nlp-color.svg": 9150,
	"./noto-sc-bold.woff2": 7116,
	"./noto-sc-light.woff2": 9818,
	"./noto-sc-medium.woff2": 9886,
	"./noto-sc-regular.woff2": 4037,
	"./points-for-hotel-stays-nlp-color.svg": 6042,
	"./priority-line-nlp-color.svg": 338,
	"./priority-list-nlp-color.svg": 1817,
	"./room-upgrade-nlp-color.svg": 9995
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3105;